import { createAction } from '@ngrx/store';

export const toggleMenu = createAction('[General] Toggle Menu');
